import { OnInit } from '@angular/core';
import { Subject } from "rxjs";
import { BsModalRef } from "ngx-bootstrap";
var ActionsPanelComponent = /** @class */ (function () {
    function ActionsPanelComponent(modalRef) {
        this.modalRef = modalRef;
        this.blocksList = [];
    }
    ActionsPanelComponent.prototype.ngOnInit = function () {
        this.onClose = new Subject();
        this.blocksList = this.dagSourceModel.getBlocksSource().getBlockList(this.nodeOptions.workflowType, this.objectName);
    };
    ActionsPanelComponent.prototype.onCloseModal = function () {
        this.onClose.next(true);
        this.modalRef.hide();
    };
    return ActionsPanelComponent;
}());
export { ActionsPanelComponent };
